import clsx from 'clsx';
import { FacetItemModel } from 'types/filter-types';

const FilterByLocationType = (props: {
	item: FacetItemModel;
	facetId: string;
	onChange: (facetId: string, id: string, active: boolean) => void;
	className?: string;
}) => {
	const { facetId, item, onChange, className } = props;

	const handleClick = () => {
		onChange(facetId, item.id, !item.active);
	};

	return (
		<li tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleClick()}>
			<label
				htmlFor={`${facetId}-${item.id}`}
				className={clsx(
					'flex items-center gap-2 cursor-pointer mr-4',
					className
				)}
			>
				<input
					type="radio"
					name={facetId}
					id={`${facetId}-${item.id}`}
					value={item.id}
					checked={item.active}
					onClick={handleClick}
					onChange={() => {}}
					className="sr-only"
				/>
				<span
					className={clsx(
						'w-4 h-4 rounded-full border  flex items-center  justify-center flex-shrink-0',
						item.active ? 'border-blue' : 'border-black'
					)}
				>
					{item.active && (
						<span className="w-full h-full rounded-full bg-blue" />
					)}
				</span>
				<span className="whitespace-no-wrap text-sm">{item.name}</span>
			</label>
		</li>
	);
};

export default FilterByLocationType;
